<template>
	<div class="manage margin-left">
		<div class="flex align-center justify-between">
			<p class="flex align-center">
				<span class="text-df text-999 margin-right-sm">当前创建发票抬头</span>
				<span class="text-sm text-theme">共 {{count}} 个</span>
			</p>
			<p class="flex align-center pointer" @click="fect('addinvoice')">
				<img src="../../../assets/img/you_icon.png" >
				<span class="text-df text-theme">创建抬头</span>
			</p>
		</div>
		<div class="margin-top">
			<el-row :gutter="20">
				<el-col :span="12" v-for="(item,index) in list" :key="index">
					<div class="header-item margin-bottom pointer" @click="chose(item)">
						<div class="">
							<p class="text-lg text-theme text-left">{{item.type | fitytype}}</p>
							<p class="flex justify-start margin-top">
								<span class="text-999 text-sm margin-right-sm">开票对象</span>
								<span>{{item.name}}</span>
							</p>
							<p class="flex justify-start">
								<span class="text-999 text-sm margin-right-sm">发票类型</span>
								<span>{{item.invoice_type | fityinvoice}}</span>
							</p>
						</div>
						<img @click.stop="edit(item)" class="pointer edite" src="../../../assets/img/edite.png" >
						<i @click.stop="del(item)" class="el-icon-error error pointer"></i>
						<p class="moren text-theme" v-if="index == 0">默认</p>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				page:1,
				list:[],
				count:0,//总数
			}
		},
		created() {
			this.getlist()
		},
		methods: {
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type) {
				let typeq = {
					type: type,
					typeone: 'apply'
				}
				this.$emit('gettype', typeq)
			},
			//TODO  分页
			getlist(){
				this.ajax('get', '/api/invoiceHead/getList', {
					page:this.page
				},res => {
					console.log(res);
					this.list = res.data.data
					this.count = res.data.count
				})
			},
			//编辑
			edit(item){
				this.fect('addinvoice')
				setTimeout(()=>{
					Bus.$emit('edit',item)
				},500)
			},
			//删除
			del(item){
				this.ajax('post', '/api/pc/invoicehead/delete', {
					id:item.id
				},res => {
					if(res.status == 200){
						this.$message('删除成功');
						this.getlist()
					}else{
						this.$message(res.msg);
					}
					
				})
			},
			chose(item){
				let type = {
					type:'apply',
					typeone:''
				}
				this.$emit('gettype',type)
				setTimeout(()=>{
					Bus.$emit('backData',item)
				},500)
			}
		},
		filters:{
			fitytype(val){
				switch (val) {
					case 2:
						return '企业'
						break;
					case 1:
						return '个人'
						break;
					default:
						break;
				}
			},
			fityinvoice(val){
				switch (val) {
					case 1:
						return '增值税普通发票'
						break;
					case 2:
						return '增值税专用发票'
						break;
					default:
						break;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.manage{
		width: 921px;
		
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2);
		border-radius: 20px;
		padding: 41px 57px;
	}
	.header-item{
		width: 386px;
		height: 155px;
		border: 1px solid #E6E6E6;
		background: linear-gradient(0deg, #EEF7F6 0%, #F8FAFA 100%);
		border-radius: 20px;
		padding: 30px 21px ;
		position: relative;
		.edite{
			position: absolute;
			width: 25px;
			height: 23px;
			right: 19px;
			bottom: 21px;
		}
		.error{
			font-size: 30px;
			position: absolute;
			right: -10px;
			top: -10px;
		}
		.moren{
			width: 49px;
			height: 23px;
			line-height: 23px;
			background: #FFFFFF;
			border: 1px solid #0B837C;
			border-radius: 6px;
			position: absolute;
			right: 20px;
			top:20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/invoice/manage.vue